import Styled from 'styled-components'
import Button from 'components/Button';

export const SearchContainer = Styled.div`
  background: transparent;
  width: 100%;
  padding-top: 16px;
`

export const SearchTitle = Styled.p`
  font-family: var(--font-family-base);
  font-weight: 600;
  font-size: 20px;
  color: var(--title-color);
  margin: 0;
  letter-spacing: -0.8px;
`

export const SearchContent = Styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const OriginDestinationWrapper = Styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
`

export const SwapButtonAnchor = Styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
`

export const SwapHint = Styled.p`
  margin: 8px 0 0;
  font-family: var(--font-family-base);
  font-size: 12px;
  font-weight: 500;
  line-height: 100%;
  color: var(--primary-color);
`

export const InputItem = Styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--text-color);
  width: 100%;

  .icon-container {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-color);

    svg {
        width: 100%;
        height: 100%;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    flex: 1;

    label {
      font-family: var(--font-family-base);
      font-weight: 400;
      font-size: 11px;
      color: #757575;
      margin: 0;
      letter-spacing: -0.8px;
    }

    .value {
      font-family: var(--font-family-base);
      font-weight: 700;
      font-size: 15px;
      color: var(--text-color);
      letter-spacing: -0.8px;
    }
    
    input {
        border: none;
        outline: none;
        font-family: var(--font-family-base);
        font-weight: 700;
        font-size: 15px;
        color: var(--text-color);
        letter-spacing: -0.8px;
        padding: 0;
        width: 100%;
        background: transparent;

        &::placeholder {
            color: #BCBCBC;
        }
    }
  }
`

export const CheckboxRow = Styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    .form-check-input {
        margin: 0;
        border-color: var(--primary-color);
    }

    .label {
        font-family: var(--font-family-base);
        font-weight: 400;
        font-size: 14px;
        color: var(--text-color);
        line-height: 100%;
    }
`

export const GridInputs = Styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
    }
`

export const SearchButton = Styled.button`
  background: var(--button-primary-color);
  color: var(--button-primary-text);
  border: none;
  padding: 16px;
  width: 100%;
  font-family: var(--font-family-base);
  font-weight: 500;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: -0.8px;
  cursor: pointer;
  margin-top: 8px;

  &:hover {
    opacity: 0.9;
  }
`

export const SummaryContainer = Styled.div`
  background: var(--background-app);
  border-bottom: 1px solid #C6C6C5;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 1px 1px 8px 0px rgba(0, 0, 0, 0.16);
  width: 100%;
  cursor: pointer;
`

export const SummaryContent = Styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const SummaryTitle = Styled.p`
  font-family: var(--font-family-base);
  font-weight: 600;
  font-size: 14px;
  color: var(--title-color);
  margin: 0;
  line-height: normal;
`

export const SummaryDetails = Styled.p`
  font-family: var(--font-family-base);
  font-weight: 400;
  font-size: 14px;
  color: var(--text-color);
  margin: 0;
  line-height: normal;
`

export const EditButton = Styled.p`
  font-family: var(--font-family-base);
  font-weight: 600;
  font-size: 14px;
  color: var(--primary-color);
  margin: 0;
  text-decoration: underline;
  cursor: pointer;
`

export const FilterSortContainer = Styled.div`
    display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 10px 0 12px;
  background: transparent;
  width: 100%;
  margin-top: 8px;

  .left-side {
    display: flex;
    align-items: center;
  }

  .right-side {
    display: flex;
    align-items: center;
  }
`

export const FilterCountBadge = Styled.span`
  background-color: var(--primary-color);
  color: var(--button-primary-text);
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 14px;
`;

export const ResultsCount = Styled.p`
  padding: 8px 0 0 2px;
  font-size: 14px;
  color: var(--text-color);
`;

export const FilterButton = Styled(Button)`

`

export const SortSelectWrapper = Styled.div`
  display: flex;
  align-items: center;
  position: relative;
  min-width: 180px;
  border-bottom: 2px solid var(--primary-color);
  padding-bottom: 4px;

  select {
    border: none;
    outline: none;
    background: transparent;
    font-family: var(--font-family-base);
    font-weight: 700;
    font-size: 15px;
    color: var(--primary-color);
    padding: 0 25px 0 0;
    appearance: none;
    cursor: pointer;
    width: 100%;
    
    option {
      color: var(--text-color);
      font-weight: 500;
    }
  }

  .arrow-icon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: var(--primary-color);
  }
`

export const QuickSorters = Styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 24px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const SorterButton = Styled.div`
  background: ${props => props.active ? 'var(--primary-color)' : 'var(--background-app)'};
  border: 1px solid #C6C6C5;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  .label {
    font-family: var(--font-family-base);
    font-weight: 700;
    font-size: 13px;
    color: ${props => props.active ? 'var(--button-primary-text)' : 'var(--text-color)'};
    text-transform: uppercase;
    margin-bottom: 4px;
    letter-spacing: -0.8px;
  }

  .desc {
    font-family: var(--font-family-base);
    font-weight: 400;
    font-size: 11px;
    color: ${props => props.active ? '#CCCCCC' : '#757575'};
  }

  &:hover {
    border-color: var(--primary-color);
    background: ${props => props.active ? 'var(--primary-color)' : '#F9F9F9'};
  }
`
